// ICON Definitions
export function getIcon(name) {
    let iconMap = Object.freeze({
        new: "mdi-plus-circle-outline",
        edit: "mdi-pencil-outline",
        save: "mdi-checkbox-marked-circle",
        cancel: "mdi-close-circle",
        close: "mdi-close-circle",
        help: "mdi-help-circle",
        approve: "mdi-stamper"
    })
    return iconMap[name]
}